module.exports = __webpack_public_path__ + "static/media/green_circles.71243d55.svg";